import React from "react";
import useMakeScrollable from "custom_hooks/make-scrollable";
import arrow from "../../assets/images/right_arrow.png"

export function SurveyItem({ survey, onClick }) {

  useMakeScrollable();

  return (
    <div 
      className='survey-block'
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      <div
        className=''
      >
        <p className=''>{survey.name}</p>
      </div>
      <div className="appointment-arrow">
        <img src={arrow} className="appointment-project-arrow"/>
      </div>
    </div>
  );
}
